'use client';

import { useTranslation } from '@/i18n/LocaleProvider';
import { T } from '@/i18n/LocaleProvider';
import Link from 'next/link';
import { Logo } from '@/components';
import LanguageSelector from '@/i18n/LanguageSelector';
import styles from './Footer.module.scss';
import { FOOTER_LINKS_ALL, filterGroupsByPhase } from '@/constants/phases';
import { SOCIAL_LINKS } from '@/constants/social';
import CookiePrefsLink from '@/components/CookiePrefsLink';

const FOOTER_LINKS = filterGroupsByPhase(FOOTER_LINKS_ALL);

// Redes en 2 filas; cada botón conserva el ancho de su texto.
const SOCIAL_SORTED = [...SOCIAL_LINKS].sort((a, b) =>
  a.label.localeCompare(b.label, 'es')
);
const SOCIAL_SPLIT = Math.ceil(SOCIAL_SORTED.length / 2);
const SOCIAL_ROWS = [
  SOCIAL_SORTED.slice(0, SOCIAL_SPLIT),
  SOCIAL_SORTED.slice(SOCIAL_SPLIT),
];

export default function Footer() {
  const t = useTranslation();
  const year = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <div className="wrap">
        <div className={styles.grid}>
          <div className={styles.brand}>
            <Logo dark />
            <p>
              <T>Haz que la Inteligencia Artificial hable de tu marca.</T>
              <br />
              <T>
                Plataforma AEO/GEO e Inteligencia de visibilidad en IA en
                español.
              </T>
            </p>
          </div>

          {Object.entries(FOOTER_LINKS).map(([section, links]) => (
            <div key={section} className={styles.col}>
              <p className={styles.navLabel}>
                <T>{section}</T>
              </p>
              <ul>
                {links.map(({ label, href }) => (
                  <li key={href}>
                    <Link href={href}>
                      <T>{label}</T>
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className={styles.socialRow}>
          <div className={styles.social}>
            {SOCIAL_ROWS.map((row, i) => (
              <div key={i} className={styles.socialLine}>
                {row.map(({ id, label, href, d }) => (
                  <a
                    key={id}
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={label}
                    className={styles.socialLink}
                  >
                    <svg
                      viewBox="0 0 24 24"
                      fill="currentColor"
                      aria-hidden="true"
                    >
                      <path d={d} />
                    </svg>
                    <span>
                      <T>{label}</T>
                    </span>
                  </a>
                ))}
              </div>
            ))}
          </div>
          <a
            href="#"
            aria-label={t('Volver al inicio')}
            className={styles.backToTop}
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              aria-hidden="true"
            >
              <path
                d="M8 13V3M3 8l5-5 5 5"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </a>
        </div>

        <div className={styles.bottom}>
          <span className={styles.legalGroup}>
            <span>
              © <T>{year}</T>
              <T> BISON AGENTS · TODOS LOS DERECHOS RESERVADOS</T>
            </span>
            <CookiePrefsLink className={styles.prefsLink} />
          </span>
          <span className={styles.region}>
            <T>SANTIAGO · CHILE</T>
            <LanguageSelector dark />
          </span>
        </div>
      </div>
    </footer>
  );
}
